import { apiSlice } from "./apiSlice";
import domain from "../util/domain";
const ADMIN_URL = `${domain}/api/admin`;

export const adminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllParentalRating: builder.query({
      query: () => ({
        url: `${ADMIN_URL}/parentalrating`,
      }),
      providesTags: ["ParentalRating"],
    }),
    getAllGenre: builder.query({
      query: () => ({
        url: `${ADMIN_URL}/genre`,
      }),
      providesTags: ["Genre"],
    }),
    getAllSubgenre: builder.query({
      query: () => ({
        url: `${ADMIN_URL}/subgenre`,
      }),
      providesTags: ["Genre"],
    }),
    getSubGenreByGenre: builder.query({
      query: (genre) => ({
        url: `${ADMIN_URL}/subgenrebygenre/${genre}`,
      }),
    }),
  }),
});

export const {
  useGetAllParentalRatingQuery,
  useGetAllGenreQuery,
  useGetAllSubgenreQuery,
  useGetSubGenreByGenreQuery,
} = adminApiSlice;

// 668d95b2b05c5fb6d1bb25af genre
// 668d95b2b05c5fb6d1bb25fb subgenre